
import Image from "next/image";
import Wave from "@/components/ui/wave";
import Logo from "@/components/ui/logo";

export default function SidebarHeader({ title }: { title: string }) {
    return (
        <>
            <Wave className="absolute z-20 -ml-4 w-[110%] rotate-180 fill-slate-800 stroke-amber-400 stroke-[5px]" />
            <div className="fixed left-0 top-0 z-30 flex w-full items-center justify-between border-t-2 border-slate-50 px-2 py-2">
                <div className="ml-2 flex flex-row items-center gap-2">
                    <Logo className="h-12 w-12 fill-slate-50 stroke-slate-50" />
                    <p className="ml-2 mt-2 text-xl font-bold text-slate-50">{title}</p>
                </div>
            </div>
        </>
    )
}